import { Injectable } from '@angular/core';

declare global {
  interface Window {
    Featurebase: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class FeaturebaseService {
  constructor() {}

  loadFeaturebaseSDK(callback: () => void) {
    const scriptId = 'featurebase-sdk';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://do.featurebase.app/js/sdk.js';
      script.onload = callback;
      document
        .getElementsByTagName('script')[0]
        .parentNode!.insertBefore(
          script,
          document.getElementsByTagName('script')[0]
        );
    } else {
      callback();
    }
  }

  identifyUser(
    email: string,
    name: string,
    id: string,
    profilePicture: string,
    callback: (err?: any) => void
  ) {
    if (typeof window !== 'undefined' && window.Featurebase) {
      window.Featurebase(
        'identify',
        {
          organization: 'unifiedfitnessplatform',
          email: email,
          name: name,
          id: id,
        },
        callback
      );
    } else {
      callback(new Error('Featurebase SDK not loaded'));
    }
  }

  initializeChangelogWidget() {
      window.Featurebase('initialize_changelog_widget', {
        organization: 'unifiedfitnessplatform',
        placement: 'right',
        fullscreenPopup: true,
        alwaysShow: true,
        theme: 'light',
      });
  }

  initializefeedbackWidget(email: string) {
      window.Featurebase('initialize_feedback_widget', {
        organization: 'unifiedfitnessplatform',
        theme: 'light', // required
        email: email, // optional
      });
  }

  initializeSurveyWidget(email: string) {
    window.Featurebase('initialize_survey_widget', {
      organization: 'unifiedfitnessplatform',
      placement: 'bottom-right',
      theme: 'light',
      email: email,
      locale: 'en',
    });
}

}
